import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useParams} from 'react-router-dom';

import {useSubscriptionItems} from '../hooks/useSubscriptionItems.ts';


export const ReloadRecordsButton = () => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    const {fetchRecords} = useSubscriptionItems(customerId);
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
